import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';


@Component({
  selector: 'app-client-group-listing',
  templateUrl: './client-group-listing.component.html',
  styleUrls: ['./client-group-listing.component.scss']
})
export class ClientGroupListingComponent implements OnInit {
  private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
  public userListingUrl = BaseUrlConstantsService.END_USER_LIST;
  public siteUsersListingUrl = BaseUrlConstantsService.SITE_USERS_LIST;
  public applicationDeleteUrl = BaseUrlConstantsService.DELETE_APPLICATIONS;
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public checked = false;
  public groupList: any = [];
  public selectValueArr = [];
  public siteID: any;
  public siteName: any;
  public pageName: string;
  public groupArr: any = [];
  public showEmptyError = '';
  public _siteUsersList: any = [];
  public _userList: any = [];
  public userList: any = [];
  public breadcrumbsArray: any = [{
    page_ref: 'site-groups',
    page_title: 'site'
  }, {
    page_ref: 'client-group-list',
    page_title: 'Applications'
  }];

  constructor(
    public router: Router,
    private changeService: ChangeUsersService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    private service: BackendApiService) {
    activeRoute.queryParams.subscribe(params => {
      this.siteID = params[`siteID`];
      this.siteName = params[`siteName`];
      this.pageName = params[`pageRef`];
      if (this.pageName === 'managerAssets') {
        const myObj = {
          page_ref: 'manager-client-list',
          page_title: 'manager clients'
        };
        this.breadcrumbsArray.unshift(myObj);
      }
    });
  }


  showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '150px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteApplication(id, index);
      }
    });
  }

  deleteApplication(id, index){
      this.service.deleteInfo(this.applicationDeleteUrl + "/" + id).then(res => {
        if (JSON.parse(JSON.stringify(res)).data.message.includes("successfully deleted")) {
          this.service.showSuccess('Successfully deleted.');
          this.groupArr.splice(index, 1);
          if (this.groupArr.length === 0) {
            this.showList = false;
            this.emptyMsg = true;
          }
        } else {
          this.service.showSuccess('Something went wrong.');
        }
      });
    }
  

  goToVisit(clientName: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        clientName
      }
    };
    this.router.navigate(['manager-users-site-group'], navigationExtras);
  }


  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : ''
      }
    };
    this.router.navigate([name], navigationExtras);
  }


  ngOnInit() {
    this.getGroupsBySiteId();
  }

  getGroupsBySiteId() {
    this.changeService.loader(true);
    this.service.getData(this.getApplicationsUrl + "/" + localStorage.getItem('user_id') + "/" + this.siteID).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
      
        if(JSON.parse(JSON.stringify(res)).data.body.body !== undefined){
          this.groupList = JSON.parse(JSON.stringify(res)).data.body.body;
        }else{
          this.groupList = JSON.parse(JSON.stringify(res)).data.body;
        }
        this.groupArr = this.groupList;
        if (this.groupList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }

  searchData(ev) {
    const term = ev.toLowerCase();
    this.groupArr = this.groupList.filter(
      result => result.name.toLowerCase().indexOf(term) >= 0);
    if (this.groupArr.length === 0) {
      this.showEmptyError = 'No Results';
    } else {
      this.showEmptyError = '';
    }
  }

  async addClients() {
    this.router.navigate(['/add-group']);
  }
 
  editGroup(groupid, groupname, siteid, sitename) {
    const navigationExtras = {
      queryParams: {
        pid: true,
        pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : '',
        pageType: 'edit-group',
        siteID: siteid,
        siteName: sitename,
        groupName: groupname,
        groupID: groupid
      }
    };
    this.router.navigate(['/add-group'], navigationExtras);
  }
  // const handleDecrement = () => {
  //   count--;
  //   totalCount.innerHTML = count;
  // };
  showListOfUsers(_groupId, _siteId) {
    this._siteUsersList = [];
    this._userList = [];
    this.userList = [];
    let _associateUsers: any = 0;
    const body = {
      client_id: localStorage.getItem('user_id')
    };
    const applicationUserBody = {
      application_id: _groupId
    }
    this.service.getData(this.siteUsersListingUrl+"/"+ _groupId +"/"+ localStorage.getItem('user_id')).then(response => {
      this._siteUsersList = JSON.parse(JSON.stringify(response)).data.body;
      this.service.getData(this.userListingUrl + "/" + Math.floor(Math.random() * 90 + 10) + localStorage.getItem('user_id') + Math.floor(Math.random() * 9000 + 1000) ).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.userList = JSON.parse(JSON.stringify(res)).data.body;
          if (this.userList.length > 0) {
            for (let i = 0; i < this.userList.length; i++) {
              let user = this._siteUsersList.filter(data => data.id == this.userList[i].id);
              if (user != null && user.length > 0) {
                _associateUsers = this._siteUsersList.length;
                this._userList.push({ "id": user[0].id, "userid": this.userList[i].id, "full_name": this.userList[i].full_name, "email": this.userList[i].email, "checked": true });
              } else {
                this._userList.push({ "id": null, "userid": this.userList[i].id, "full_name": this.userList[i].full_name, "email": this.userList[i].email, "checked": false });
              }
            }
          }

          const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
            width: '650px',
            data: {
              type: 'ClientGroupAssociateUsers',
              userList: this._userList,
              siteid: _siteId,
              group_id: _groupId,
              _associateUsers: _associateUsers
            }
          });
        } else {
          this.showList = false;
          this.emptyMsg = true;
          this.service.showError('Something went wrong.');
        }
      });
    });
  }

  addApplication(id, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : '',
        siteID: id,
        siteName: name
      }
    };
    this.router.navigate(['/add-group'], navigationExtras);
  }

  showLicense(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: 'adminLicense',
      }
    });
  }
}
